export interface SkuScoreItem {
  id: string;
  name: string;
}
export interface SkuItem {
  skuId: string;
  skuTitle: string;
  skuImage: string;
  skuScoreList?: SkuScoreItem[];
  propertyExt?: string;
  commentId?: string | number;
}
export interface WaitingReviewRes {
  beginTime: string;
  completeTime: string;
  orderId: string;
  commentSkuList: SkuItem[];
}

export interface UserWaitingReviewResponse {
  total?: number;
  data?: WaitingReviewRes[];
  bannerView?: object;
}

export interface ImageObj {
  imageUrl: string;
}
export interface VideoObj {
  videoUrl: string;
}
export interface ReviewedRes {
  commentId: string;
  skuId: string;
  skuImage: string;
  skuTitle: string;
  propertyExt: string;
  star: number;
  imageList: ImageObj[];
  videoList: VideoObj[];
  commentDate: string;
  commentNum: number;
  anonymousFlag: boolean;
  helpfulNum: string;
  nickName: string;
  content: string;
  currentIsHelp: boolean;
  parentReplyId?: string | number;
  orderId?: string | number;
  approvalResult?: string;
  tipType?: string | number;
  visible?: string;
  tipDescription?: string;
  invisibleStr?:string;
  invisibleDescription?: string;
}

export enum ReviewTipType {
  Normal = 1, //正常展示
  Report = 2, //举报成功/审核失败
}

export interface UserReviewedResponse {
  total?: number;
  data?: ReviewedRes[];
}

export interface ServiceScoreList {
  id: string;
  name: string;
}

export interface CommentContentResponse {
  orderId: string;
  completeTime: string;
  orderTime: string;
  beginTime: string;
  commentSkuList: SkuItem[];
  serviceScoreList: ServiceScoreList[];
}

export interface SaveCommentParams {
  orderId: string;
  skuId: string;
  content?: string;
  anonymous: boolean;
  scoreList: (number | null)[];
  imageList?: string[];
  ugcVideoList?: string[];
}

export interface ImageItem {
  imageUrl: string;
}
export interface ReplayItem {
  replyId: string;
  userNickName: string;
  userImage: string;
  commentDate: string;
  content: string;
  parentReplyId: string;
  canDelete: boolean;
  replyNickname: string;
}

export interface VideoItem {
  videoUrl: string;
}
export interface CommnentSku {
  saleAttr?: string;
}

export interface SecondaryReply {
  id: string;
  replyId: string;
  userNickName: string;
  userImage: string;
  commentDate: string;
  content: string;
  parentReplyId: string | number;
  canDelete: boolean;
  replyNickname: string;
  tag: string | null;
}
export interface ReviewDetailItem {
  star: string;
  userNickName: string;
  currentIsUseful: boolean;
  commentId: string;
  commentSku: CommnentSku;
  userImage: string;
  propertyExt: string;
  commentDate: string;
  content: string;
  replyTreeCount: number;
  usefulVoteCount: number;
  usefulVoteResult: boolean;
  imageList: ImageItem[];
  replayList: ReplayItem[];
  videoList: VideoItem[];
  parentReplyId?: number | string;
  replyList?: SecondaryReply[];
  commentNum: number;
  usefulNum: number;
  anonymousFlag: boolean;
}
export interface UserReviewedDetailResponse {
  msg: string;
  code: string;
  data?: ReviewDetailItem;
}

export interface PublishReplyReq {
  commentId: string;
  targetReplyId?: string;
  parentReplyId?: string | number;
  content: string;
  anonymousFlag: boolean;
  canDelete?: boolean;
}

export interface PublishRes {
  data: { saveResult: boolean };
}

export interface HelpfulReqParams {
  commentId: string;
  operation: number;
}

export interface HandleHelpfulRes {
  msg: string;
  data: {
    likeCount: string;
    result: boolean;
  };
}

export interface HelpfulProps {
  commentId: string;
  currentIsHelp: boolean;
  helpfulNum: string;
}

export interface DeleteCommentReqParams {
  commentId: string;
  skuId: string;
}

export interface DeleteCommentRes {
  data: { deleteResult: boolean };
}

export interface anonymousData {
  nickName: string;
  userImage: string;
  commentId: string;
}
export interface AnonymousRes {
  data: { setResult: boolean } & anonymousData;
}

export interface DeleteReplyParams {
  skuId: string;
  replyId: string;
}

export interface DeleteReplyRes {
  data: { deleteResult: boolean };
}
